import React, { useState, useEffect } from "react";
import Container from "olive-react-myoneui/lib/Container";
import Row from "olive-react-myoneui/lib/Row";
import Col from "olive-react-myoneui/lib/Col";
import CourseEventsHeader from "./courseEventsHeader";
import CourseEventsListing from "./courseEventsListing";
import DropdownCommon from "../DropdownCommon";
import { timeZoneList } from "../../../constants/timeZoneList";
import { useSelector } from "react-redux";

function EventListings({coursedetails}) {
  const timeZones     = coursedetails?.timezones;
  const userTimeZone  = coursedetails?.user_timezone;
  const itemType      = 'bms_course';
  const miscellaneous = useSelector((state) => state.user.miscellaneous);
  const paths         = useSelector((state) => state.user.paths);
  const [selectedTimeZone, setSelectedTimeZone]       = useState('');
  // const [selectedTimeZoneTxt, setSelectedTimeZoneTxt] = useState('');
  
  const changeTimeZone = (e) => {
    let timeZone    = e?.name_without_offset;
    let timeZoneTxt = e?.name;
    setSelectedTimeZone(timeZoneList[timeZone]);
    // setSelectedTimeZoneTxt(timeZoneTxt);

    localStorage.setItem("selected_timezone", timeZone);
    localStorage.setItem("selected_timezone_txt", timeZoneTxt);

    if(timeZone == "") {
      localStorage.removeItem("selected_timezone");
      localStorage.removeItem("selected_timezone_txt");
    }
    localStorage.selected_timezone      = timeZone;
    localStorage.selected_timezone_txt  = timeZoneTxt;

  }

  useEffect(() => {
    // if(timeZones !== undefined)
    // setTimeZone();
  },[coursedetails, timeZones]);
  useEffect(() => {
    const selectedTimeZoneTemp =  timeZoneList[localStorage.getItem("selected_timezone") ? localStorage.getItem("selected_timezone") : miscellaneous.configured_time_zone];
    setSelectedTimeZone(selectedTimeZoneTemp);
  },[timeZoneList]);
  const defaultObj = {"value": selectedTimeZone.name_without_offset, "name":selectedTimeZone.name};
  return (
    <>
      <CourseEventsHeader isCertificateAvailable={coursedetails?.course?.bbc_certificate_available} itemBannerImage={paths.event_path + coursedetails?.course?.bbc_banner} itemTitle={coursedetails?.course?.bbc_name} itemDescription={[coursedetails?.course?.bbc_summary]} className="mb-4"/>
      <Container>
        <Row className="course-inner-heading align-items-center px-2 mb-3 res-course-inner-heading">
          <Col lg={9} className="res-order-2">
            {(coursedetails && coursedetails.event_data && coursedetails.event_data.length > 0) && 
              <h1>Available Dates</h1>
            }
          </Col>
          <Col lg={3} className="res-order-1">
            {/* <DropdownCommon defaultValue={defaultObj} items={timeZones} label={'Select Timezone'} onChange={changeTimeZone} className="mb-0" /> */}
            <DropdownCommon defaultValue={defaultObj} items={Object.values(timeZoneList)} label={'Select Timezone'} onChange={changeTimeZone} className="mb-0" />
          </Col>
        </Row>
        {(coursedetails && coursedetails.event_data && coursedetails.event_data.length == 0) && 
          <Row className="px-2 mt-6">
            <Col lg={12}>
              <p><br/><br/>
              <h3 style={{textAlign:'center'}}>No training dates available at the moment</h3>
                <br/><br/>
              </p>
            </Col>
          </Row>
        }
        <Row className="px-2">
          <Col lg={12}>
            <CourseEventsListing courseDetails={coursedetails} selectedTimeZone={selectedTimeZone}/>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default EventListings;

